// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"6fe7b3ec9b40eea6a819","243":"b9e49f0c4364bb5ead67","682":"42decabe499554162257","688":"8a5a0167c00ab3ec2523","738":"159aea2b5e99d2920a92","765":"85e2cb3a12e4732aa483","852":"7842467aaae06d67cd06"}[chunkId] + ".bundle.js";
};